import React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

// sonner の既定（幅 356px・文字 13px・余白 16px・アイコン 16px）では読みにくいため、一回り大きくする
// 既定のスタイルは [data-sonner-toast][data-styled='true'] で詳細度が高いため、important 付きのクラスで上書きする
// スマホ幅（600px 未満）では sonner が画面幅いっぱいに広げるため、--width は PC・タブレットだけに効く
const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="light"
    position="top-right"
    containerAriaLabel="通知"
    className="toaster group"
    toastOptions={{ classNames: { toast: '!p-5 !text-title', icon: '!size-5' } }}
    style={
      {
        '--width': '420px',
        '--normal-bg': 'var(--background)',
        '--normal-text': 'var(--foreground)',
        '--normal-border': 'var(--border)',
      } as React.CSSProperties
    }
    {...props}
  />
);

export { Toaster };
